class Modal {
    constructor(title, content, className) {
        var self = this;
        self.uid = Math.random().toString(36).substr(2, 9);
        self.modal = $('<div class="modal-dialog" role="dialog" tabindex="-1"/>');
        self.content = $('<div class="dialog-content"/>').appendTo(self.modal);
        self.modal.data('modal', self);
        if (title.length > 0) {
            self.title = $('<h2/>').attr('id', 'modal-title-' + self.uid).text(title).appendTo(self.content);
            self.modal.attr('aria-labelledby', 'modal-title-' + self.uid);
        }
        self.contentContainer = $('<div class="content-container"/>').appendTo(self.content);
        self.buttonContainer = $('<div class="button-container"/>').appendTo(self.content);
        // self.closeButton = $('<div class="close"/>').appendTo(self.modal).on('click',function(){
        // 	self.close();
        // });
        if (content.length > 0) self.addContent(content);
        if (className) self.modal.addClass(className);
    }
    show() {
        var self = this;
        if (Modal.modals.indexOf(self) === -1) {
            Modal.modals.push(self);
            if (self.buttonContainer.find('button').length === 0)
                self.addButton('Ok');
            Modal.overlay.removeClass('closed').appendTo(document.body);
            self.modal.attr('aria-modal', 'true').appendTo(document.body);
            self.buttonContainer.find('button').first().focus();
        }
        return self;
    }
    close() {
        var self = this;
        if (Modal.modals.indexOf(self) !== -1) {
            Modal.modals.splice(Modal.modals.indexOf(self), 1);
            Modal.overlay.addClass('closed');
            self.modal.addClass('closed');
            setTimeout(function() {
                self.modal.remove();
                Modal.overlay.remove();
            }, 300);
        }
        return self;
    }
    addButton(label, callback) {
        var self = this;
        if (typeof callback === 'undefined')
            var action = self.close;
        else
            var action = function() { self.close(); callback(); };
        var button = $('<button/>').text(label).appendTo(self.buttonContainer).on('click', action.bind(self));
        return self;
    }
    addContent(content, overflow) {
        var paragraph = $('<p/>').text(content).appendTo(this.contentContainer);
        if (overflow === false)
            paragraph.addClass('ellipsed').attr('title', content);
        return self;
    }
    static closeAll() {
        $.each(Modal.modals, function() {
            this.close();
        });
    }
}

Modal.modals = [];

Modal.overlay = $('<div id="modal-overlay"/>').on('click',function(){
	Modal.closeAll();
});

// jQuery helper

$.modal = function(title, content, className) {
    return new Modal(title, content, className);
}
